import request from '@/utils/request'

export function businessCardRecordList(params = {}) {
  return request({
    url: '/spWorkWechat/wwScript/businessCard/record',
    method: 'get',
    params
  })
}

export function businessCardRecordRepush(data = {}) {
  return request({
    url: '/spWorkWechat/wwScript/businessCard/rePush',
    method: 'post',
    data
  })
}
